module.exports = "https://d3r7nsslvs6aaf.cloudfront.net/frontend/1b197605f21fe7603b2abb33d76ad079.svg";